import React, {FC} from 'react';
import styled from 'styled-components';

import {InboxesPanelId} from '../../store/panels/panelStateBase';
import {topBarHeight} from '../app/topBar/topBarHelpers';
import {VisitorUnsubscribedAllBannerContainer} from './banner/visitorUnsubscribedAllBannerContainer';
import {VisitorConversationsContainer} from './cells/visitorConversationsContainer';
import {VisitorExperienceTopBar} from './visitorExperienceTopBar';
import {VisitorViewerSidebar} from './visitorViewerSidebar';

/*
 * Props.
 */

interface VisitorExperienceProps {
  panelId: InboxesPanelId;
}

/*
 * Style.
 */

const StyledContainerDiv = styled.div`
  display: flex;
  flex-flow: row;
  height: 100%;
  position: relative;
`;

const StyledGridDiv = styled.div`
  min-height: 250px;
  height: 100%;
`;

const StyledInboxesContainerDiv = styled.div`
  height: calc(100% - ${topBarHeight}px);
  width: 100%;
  border-left: 1px solid ${(p) => p.theme.greys.shade40};
  overflow: hidden;
`;

/*
 * Component.
 */

export const VisitorExperience: FC<VisitorExperienceProps> = (props) => {
  const {panelId} = props;
  return (
    <StyledGridDiv>
      <VisitorExperienceTopBar />
      <VisitorUnsubscribedAllBannerContainer />
      <StyledContainerDiv>
        <StyledInboxesContainerDiv>
          <VisitorConversationsContainer panelId={panelId} />
        </StyledInboxesContainerDiv>
        <VisitorViewerSidebar />
      </StyledContainerDiv>
    </StyledGridDiv>
  );
};
